import { render } from "./ActivationSuccess.vue?vue&type=template&id=2fb972e8&scoped=true&ts=true"
import script from "./ActivationSuccess.vue?vue&type=script&lang=ts"
export * from "./ActivationSuccess.vue?vue&type=script&lang=ts"

import "./ActivationSuccess.vue?vue&type=style&index=0&id=2fb972e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb972e8"]])

export default __exports__